var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"expandButton",class:{
      expandButtonContentStart: !_vm.justifyEnd,
      expandButtonContentEnd: _vm.justifyEnd,
    },attrs:{"flat":"","large":""},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.expandIconName))]),_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")],1),_c('v-slide-y-transition',[(_vm.showSlot)?_c('div',{class:_vm.space},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }